import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Input,
    Modal,
} from "reactstrap";
import ProductDataService from "../../services/ProductDataService";

class ProductEmoneyModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          defaultModal: false,
          currentProduct: {},
          selectedImage: null,
          imagePreview: null,
        };
        this.productDataService = new ProductDataService();
    }
      
    handleInputChanged(e) {
        let nam = e.target.name
        let val = e.target.value
        
        this.setState(prevState => {
            let currentProduct = Object.assign({}, prevState.currentProduct);
            currentProduct[nam] = val;
            return { currentProduct };
        })
    }
    
    handleImageChange(e) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();
            
            reader.onloadend = () => {
                this.setState({
                    selectedImage: file,
                    imagePreview: reader.result
                });
            };
            
            reader.readAsDataURL(file);
        }
    }

    setErrormessage(errorMessage) {
        this.setState({ errorMessage: errorMessage })            
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
    }

    handleResponse(data, successMessage) {
        if (data?.data?.errorMessage) {
            this.setState({ errorMessage: data.data.errorMessage })
        } else if (data?.header?.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {}})
            this.props.fetchData()
        }
        setTimeout(() => {
            this.setState({ successMessage: undefined, errorMessage: undefined });
        }, 5000);   
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (this.props.formType === 'edit') {
                this.handleEditProduct();
            } else {
                this.handleAddProduct();
            }
        }
    }

    handleAddProduct() {
        const { product_name, product_barcode } = this.state.currentProduct;
        const newProduct = {
            product_barcode,
            product_name,
            product_type: "eproduct"
        };

        this.productDataService.add(newProduct)
            .then((data) => {
                if (data?.data?.errorMessage) {
                    this.setState({ errorMessage: data.data.errorMessage });
                } else if (data?.header?.status_code !== 200) {
                    let errorMessages = [];
                    data?.data?.map((data) => {
                        return errorMessages.push(data?.error_message);
                    });
                    this.setState({ errorMessages: errorMessages });
                } else if (this.state.selectedImage && data?.data?.products && data?.data?.products.length > 0) {
                    const productId = data.data.products[0].product_id;
                    this.uploadProductImage(productId);
                } else {
                    this.handleResponse(data, "E-Money berhasil ditambahkan");
                }
            });
    }

    handleEditProduct() {
        const { product_id, product_name, product_barcode } = this.state.currentProduct;

        const updatedProduct = {
            product_id,
            product_name,
            product_barcode,
            product_type: "eproduct"
        };

        this.productDataService.update(updatedProduct)
            .then((data) => {
                if (data?.data?.errorMessage) {
                    this.setState({ errorMessage: data.data.errorMessage });
                } else if (data?.header?.status_code !== 200) {
                    let errorMessages = [];
                    data?.data?.map((data) => {
                        return errorMessages.push(data?.error_message);
                    });
                    this.setState({ errorMessages: errorMessages });
                } else if (this.state.selectedImage) {
                    this.uploadProductImage(product_id);
                } else {
                    this.handleResponse(data, "E-Money berhasil diubah");
                }
            });
    }
    
    uploadProductImage(productId) {
        this.productDataService.uploadImage(productId, this.state.selectedImage)
            .then((data) => {
                this.handleResponse(data, "E-Money berhasil disimpan dengan gambar");
            })
            .catch((error) => {
                console.error("Error uploading image:", error);
                this.setState({ 
                    errorMessage: "Gagal mengupload gambar, tetapi data E-Money berhasil disimpan" 
                });
            });
    }

    onModalOpened() {
        this.setCurrentProduct();
    }

    onModalClosed() {
        this.setState({ 
            currentProduct: {},
            errorMessages: [],
         })
    }

    setCurrentProduct() {
        if (this.props.formType === 'edit') {
            this.setState({ currentProduct: this.props.currentProduct })
        } else {
            this.setState({ currentProduct: {} })
        }
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
                >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent">
                        <div className="text-muted text-center mt-2 mb-3">
                            <h3 className="mb-0">{this.props.formType === 'add' ? 'Tambah E-Money baru' : 'Ubah E-Money' }</h3>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        {this.state.errorMessages && this.state.errorMessages.map((errorMessage, index) => (
                            <Alert key={index} color="danger">
                            {errorMessage}
                            </Alert>
                        ))}
                        {this.state.errorMessage && (
                            <Alert color="danger">
                            {this.state.errorMessage}
                            </Alert>
                        )}
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-barcode"
                            >
                                Barcode E-Money
                            </label>
                            <Input placeholder="Barcode E-Money"
                                className="form-control-alternative"
                                name="product_barcode"
                                id="input-barcode"
                                value={this.state.currentProduct?.product_barcode || ''}
                                onChange={this.handleInputChanged.bind(this)}
                                onKeyUp={this.onKeyUp.bind(this)}
                                type="text" />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Nama E-Money
                            </label>
                            <Input placeholder="Nama E-Money"
                                name="product_name"
                                className="form-control-alternative"
                                value={this.state.currentProduct?.product_name || ''}
                                onChange={this.handleInputChanged.bind(this)}
                                onKeyUp={this.onKeyUp.bind(this)}
                                type="text" />
                        </FormGroup>
                        <FormGroup>
                            <div className="btn-wrapper text-right">
                            <Button
                                className="my-4"
                                color="secondary"
                                type="button"
                                onClick={this.props.toggleModal}
                                >
                                Batal
                            </Button>
                            <Button
                                className="my-4"
                                color="primary"
                                type="button"
                                onClick={() => this.props.formType === 'add' ? this.handleAddProduct() : this.handleEditProduct()}
                                >
                                Simpan
                            </Button>
                            </div> 
                        </FormGroup> 
                    </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default ProductEmoneyModal;
